export enum RequestRateStatus {
  Pending = 'pending',
  Approved = 'approved',
  Denied = 'denied',
}
